/**
 * 使用说明：
 */
import React, { PureComponent } from 'react';

import {
    View,
    Image,
    TouchableOpacity,
    StyleSheet,
} from 'react-native'
import {
    JDText,
    JDTouchable
} from '@jdreact/jdreact-core-lib'

import { pt } from '../../common/utils';
import img from '../../common/img';

export default class NoMore extends PureComponent {
    constructor(props) {
        super(props);
    }


    static defaultProps = {
        txt: '没有相关信息',
        img: img.no_more,
        imgStyle: { height: pt(66), width: pt(100) },
        contentStyle: null
    }
    render() {
        let { img, contentStyle, txt, imgStyle, type, btnTxt, btnFn } = this.props;
        return (
            <View style={{paddingBottom:pt(20)}}>
                <View style={[st.wrap, contentStyle]}>
                    <Image style={[{width: pt(78), height: pt(74)},imgStyle]} source={img}></Image>
                    <JDText style={st.error_text}>{txt}</JDText>
                </View>

                {
                    type!='order' && btnTxt && <View style={st.view_bottom}>
                        <JDTouchable onPress={() => btnFn()}>
                            <View style={[st.btn_view]}>
                                <JDText style={[st.btn_txt]}>{btnTxt}</JDText>
                            </View>
                        </JDTouchable>
                    </View>
                }
            </View>
        )
    }
}

const st = StyleSheet.create({
    wrap: {
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: pt(40),
        marginBottom: pt(20)
    },
    error_text: {
        color: '#252525',
        marginTop: pt(11),
        fontSize: pt(13)
    },
    view_bottom: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    btn_view: {
        height: pt(34),
        paddingHorizontal: pt(20),
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: pt(6),
        borderColor: '#E2231A',
        borderWidth: pt(1),
        backgroundColor: '#fff',
    },
    btn_txt: {
        color: '#252525',
        fontSize: pt(13)
    }
})
